import moment from "moment";
import { harvestYearDetail } from "../../config/harvestYearDetail";
import { userDetail } from "../../config/userDetails";
import { globalApiHandler } from "../../services/services";

export const TRUCKLINE = {
  getAllTrucklinesList: {
    success: "TRUCKLINE_GET_ALL_SUCCESS",
    error: "TRUCKLINE_GET_ALL_ERROR"
  },
  create: {
    success: "TRUCKLINE_CREATE_SUCCESS",
    error: "TRUCKLINE_CREATE_ERROR"
  },
  edit: {
    success: "TRUCKLINE_EDIT_SUCCESS",
    error: "TRUCKLINE_EDIT_ERROR"
  },
  update: {
    success: "TRUCKLINE_UPDATE_SUCCESS",
    error: "TRUCKLINE_UPDATE_ERROR"
  },
  delete: {
    success: "TRUCKLINE_DELETE_SUCCESS",
    error: "TRUCKLINE_DELETE_ERROR"
  }
};

export const trucklineListAction = (harvestYear = harvestYearDetail().name) => {
  return (dispatch, getState) => {
    const selectedMainFarm = getState().FarmManagementReducer.MainFarmId;
    /* in case of superAdmin no parentFarmId is associated therefore using selectedMainFarm
      from mainFarm Dropdown*/
    let url = `/ntrac/truckline/farmId/${
      userDetail().parentFarmId ? userDetail().parentFarmId : selectedMainFarm
    }?harvestYear=${harvestYear}`;
    globalApiHandler(url, "get", {})
      .then(response => {
        const data = response.data.data;
        const suggestedData = response.data.suggestedData;
        data.map(item => {
          item.updatedAt = moment(item.updatedAt).format("ll");
          item.type = item.truckLineTypeEntity
            ? item.truckLineTypeEntity.type
            : "";
        });
        suggestedData.map(item => {
          item.updatedAt = moment(item.updatedAt).format("ll");
          item.type = item.truckLineTypeEntity
            ? item.truckLineTypeEntity.type
            : "";
        });
        dispatch({
          type: TRUCKLINE.getAllTrucklinesList.success,
          data,
          suggestedData
        });
      })
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
      });
  };
};

export const createTruckAction = trucklineInfo => {
  let url = `/ntrac/truckline`;
  return dispatch => {
    globalApiHandler(url, "post", trucklineInfo)
      .then(response => {
        dispatch({ type: TRUCKLINE.create.success, data: response.data });
        dispatch({ type: "SERVER_SUCCESS", data: response.data });
      })
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
      });
  };
};

export const editTruckAction = data => {
  return dispatch => {
    dispatch({ type: TRUCKLINE.edit.success, data });
  };
};

export const updateTruckAction = trucklineInfo => {
  let url = `/ntrac/truckline/${trucklineInfo.id}`;
  return dispatch => {
    globalApiHandler(url, "put", trucklineInfo)
      .then(response => {
        dispatch({ type: TRUCKLINE.update.success, data: response.data });
        dispatch({ type: "SERVER_SUCCESS", data: response.data });
      })
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
      });
  };
};

export const deleteTruckAction = id => {
  let url = `/ntrac/truckline/${id}`;
  return dispatch => {
    globalApiHandler(url, "delete", {})
      .then(response => {
        const data = response.data.data;
        dispatch({ type: TRUCKLINE.delete.success, data });
        dispatch({ type: "SERVER_SUCCESS", data: response.data });
      })
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
      });
  };
};



// WEBPACK FOOTER //
// ./src/modules/truckline/action.js